/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geototalscans2Inputs */

const en_geototalscans2 = /** @type {(inputs: Geototalscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans`)
};

const de_geototalscans2 = /** @type {(inputs: Geototalscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scans`)
};

/**
* | output |
* | --- |
* | "Scans" |
*
* @param {Geototalscans2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geototalscans2 = /** @type {((inputs?: Geototalscans2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geototalscans2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geototalscans2(inputs)
	return de_geototalscans2(inputs)
});
export { geototalscans2 as "geoTotalScans" }